import React from "react";
import "./App.css";
import Header from "./components/Header";
import Home from "./pages/Home";
import Audience from "./pages/Audience";
import Team from "./pages/Team";
import Clients from "./pages/Clients";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import * as Scroll from "react-scroll";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  let Element = Scroll.Element;

  return (
    <div className="App">
      <Header />
      <Element name="home">
        <Home id="home" />
      </Element>
      <Element name="products">
        <Products id="products" />
      </Element>
      <Element className="clients" name="services">
        <Services id="services" />
      </Element>
      <Element name="contact">
        <Contact id="contact" />
      </Element>
      <Footer />
    </div>
  );
}

export default App;
